module.exports = __webpack_public_path__ + "static/media/fatherstephen_cover.4494ebac.mp4";